// URL helpers for the My Pay workspace. The page is mounted on a splat route
// (`my-pay/*` inside TenantLayout's nested <Routes>), so relative navigation is
// ambiguous — we derive absolute bases from the current pathname instead.
import { useLocation, useNavigate } from 'react-router-dom';

export type MyPayTab = 'overview' | 'payslips' | 'earnings' | 'loans' | 'compensation' | 'reports';

const SEGMENT = '/my-pay';

export function useMyPayNav() {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();

  const idx = pathname.indexOf(SEGMENT);
  /** ".../t/:slug/app" — for deep links to sibling modules (loans, documents…). */
  const appBase = idx >= 0 ? pathname.slice(0, idx) : pathname;
  /** ".../t/:slug/app/my-pay" */
  const base = idx >= 0 ? pathname.slice(0, idx + SEGMENT.length) : `${pathname}${SEGMENT}`;

  const sub = idx >= 0 ? pathname.slice(idx + SEGMENT.length).replace(/^\//, '').split('/')[0] : '';
  const tab: MyPayTab =
    sub === 'payslips' || sub === 'earnings' || sub === 'loans' || sub === 'compensation' || sub === 'reports'
      ? sub
      : 'overview';

  const goTab = (t: MyPayTab, params?: string) =>
    navigate(`${t === 'overview' ? base : `${base}/${t}`}${params ?? ''}`);

  return { appBase, base, tab, goTab, search };
}
